export function trimStart(str, pattern) {
    if (str.startsWith(pattern)) {
        return str.slice(pattern.length);
    }
    return str;
}
export function trimEnd(str, pattern) {
    if (str.endsWith(pattern)) {
        return str.slice(0, -pattern.length);
    }
    return str;
}
export function trimStartEnd(start, str, end) {
    return trimEnd(trimStart(str, start), end);
}
